export default function () {
  return {
    messages: [],
    messagesCurrentPage: 1,
    messagesLastPage: 1,
    messagesPerPage: 0,
    messagesTotal: 0,
    messagesActiveTotal: 0,
    messagesLoading: false,
    indexPage: null
  }
}
